/**
 * Where a CanvasLayer sits in a sub-viewport pass that draws through a Camera2D's view. Godot draws
 * a layer's canvas through the layer's own transform, and a following layer's through the view too,
 * scaled about the viewport's centre (`renderer_viewport.cpp:46-86`).
 */
import { orthoViewRect } from '../nodes/viewport/subviewport/offscreenViewport.js';
/** Written only by {@link viewAnchorMatrix}, which reads it before returning. */
const view = { x: 0, y: 0, w: 0, h: 0 };
/**
 * Writes into `target` the matrix a layer's canvas draws through in the pass, before its own
 * transform. A layer that does not follow keeps its origin at the view's top-left and one viewport
 * pixel per pixel. A following layer takes the view as world content does, scaled about its centre.
 */
export function viewportLayerMatrix(follow, camera, size, target) {
    const { x, y } = camera.position;
    if (follow.enabled) {
        const s = follow.scale;
        return target.makeScale(s, s, 1).setPosition(x * (1 - s), y * (1 - s), 0);
    }
    return viewAnchorMatrix(camera, size, target);
}
/**
 * Writes into `target` the matrix that puts the top-left of a viewport-sized layout on the top-left
 * of the view `camera` frames, one viewport pixel per pixel. What a Camera2D does not move sits there.
 */
export function viewAnchorMatrix(camera, size, target) {
    const { x: left, y: bottom, w, h } = orthoViewRect(camera, view);
    return target.makeScale(w / size.x, h / size.y, 1).setPosition(left, bottom + h, 0);
}
//# sourceMappingURL=viewportLayerAnchor.js.map